module.exports = __webpack_public_path__ + "img/feedback10-2.4d66ef83.jpg";